import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WhatsappPdfRoutingModule } from './whatsapp-pdf-routing.module';
import { WhatsappPdfComponent } from './whatsapp-pdf.component';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    WhatsappPdfComponent
  ],
  imports: [
    CommonModule,
    WhatsappPdfRoutingModule,
    SharedModule,
    CommonFileUploadModule

  ], exports: [
    WhatsappPdfComponent
  ]
})
export class WhatsappPdfModule { }
